import { DateRange } from "react-day-picker"
import { fromZonedTime } from "date-fns-tz"
import { DATE_FORMATS, formatDate } from "@/lib/format-date"
import { defaultTimeZone } from "@/lib/initial-time-zone"
import { BetterDocExchangeFilter } from "@/modules/admin/better-doc/services/betterDocExchangesQuery"
import { de_BetterDocExchangeOperation } from "@/types/__generated__/union-types"

const START_OF_DAY = "T00:00:00.000"

const END_OF_DAY = "T23:59:59.999"

export type BetterDocExchangeFilterValues = {
  operation: de_BetterDocExchangeOperation | null
  isFailedOnly: boolean
  isTestCase: boolean | null
  dateRange: DateRange | undefined
}

export const INITIAL_EXCHANGE_FILTER_VALUES: BetterDocExchangeFilterValues = {
  operation: null,
  isFailedOnly: false,
  isTestCase: null,
  dateRange: undefined,
}

const toInstantInServerTimeZone = (date: Date, timeOfDay: string) =>
  fromZonedTime(`${formatDate(date, DATE_FORMATS.ISODateFormat)}${timeOfDay}`, defaultTimeZone).toISOString()

export const buildBetterDocExchangeFilter = (filterValues: BetterDocExchangeFilterValues): BetterDocExchangeFilter => {
  const { operation, isFailedOnly, isTestCase, dateRange } = filterValues
  const completeDateRange = dateRange?.from && dateRange.to ? { from: dateRange.from, to: dateRange.to } : null

  return {
    operation,
    isFailedOnly: isFailedOnly ? true : null,
    isTestCase,
    startedFrom: completeDateRange ? toInstantInServerTimeZone(completeDateRange.from, START_OF_DAY) : null,
    startedTo: completeDateRange ? toInstantInServerTimeZone(completeDateRange.to, END_OF_DAY) : null,
  }
}
